import { useDispatch } from "react-redux";
import { fetchOrganizationsAction } from "store/actions/organizations";
import { toast } from "react-toastify";
import { useCurrentUser, useLogout } from "utils/hooks";

const useFetchOrganizations = () => {
  const dispatch = useDispatch();
  const { logOut } = useLogout();
  const { user } = useCurrentUser();

  const fetchOrganizations = () => {
    return new Promise((resolve, reject) => {
      fetch(`${process.env.REACT_APP_API_URL}`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          query: `
            query {
              getOrganizations {
                uuid
                name
                description
                slug
                createdAt
                updatedAt
                location
                address {
                  address1
                  address2
                  city
                  state
                  country
                }
                numberOfUsers
                users {
                  uuid
                  userId
                  name
                  email
                  role
                  status
                  seatStatus
                  firstName
                  lastName
                  invitingTherapist
                  icon
                  color
                  type
                }
                subscription {
                  status
                  stripeCustomerId
                  seatLimit
                  seatsUsed
                }
                treatmentType
                practiceSize
                address1
                address2
                state
                zipcode
                phone
                logoId
                logoUrl
                organizationSettings {
                  uuid
                  organizationId
                  settings {
                    settingKey
                    settingValue
                    lastChangedBy
                  }
                  created_at
                  updated_at
                }
              }
            }
          `,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          organizationId: user?.activeOrganizationId || "NA",
          permissionKey: "read_organization_information",
        },
      })
        .then(async (res) => {
          if (res.status !== 200 && res.status !== 201) {
            const error = await res.json();
            if (error?.error === "Permission denied") {
              dispatch(fetchOrganizationsAction([]));
              resolve([]);
            }
            if (error?.errors?.[0]?.message?.includes("BRKN_6001")) {
              toast.warn(`For security purposes please log in again.`);
              logOut();
            } else {
              toast.error(`Hmm, something went wrong.`);
              throw new Error("Failed!");
            }
          }
          return res.json();
        })
        .then((resData) => {
          if (resData.errors) {
            toast.error(
              `Hmm, something went wrong (Code: 01IMN). ${resData.errors[0].message}`
            );
            reject(new Error(resData.errors[0].message));
          } else {
            dispatch(fetchOrganizationsAction(resData.data.getOrganizations));
            resolve(resData.data.getOrganizations);
          }
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  };

  return {
    fetchOrganizations,
  };
};

export default useFetchOrganizations;
